import { render, staticRenderFns } from "./ItsSalesOuter.vue?vue&type=template&id=2063da4c&scoped=true&"
import script from "./ItsSalesOuter.vue?vue&type=script&lang=js&"
export * from "./ItsSalesOuter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063da4c",
  null
  
)

export default component.exports